import React from "react";
import { Alert as AntdAlert } from "antd";
import {
    WarningOutlined,
    ExclamationCircleOutlined,
    InfoCircleOutlined,
    CheckCircleOutlined
} from "@ant-design/icons";

const Alert = props => {
    const { type, icon, className, title, message, ...other } = props;

    let colourClass = "";
    let extraOptions = {};

    if (type === "success") {
        colourClass = "ch-alert-success";
        extraOptions.icon = <CheckCircleOutlined />;
    } else if (type === "warning") {
        colourClass = "ch-alert-warning";
        extraOptions.icon = <WarningOutlined />;
    } else if (type === "error") {
        colourClass = "ch-alert-error";
        extraOptions.icon = <ExclamationCircleOutlined />;
    } else if (type === "info") {
        colourClass = "ch-alert-info";
        extraOptions.icon = <InfoCircleOutlined />;
    }

    return (
        <AntdAlert
            className={colourClass + (className ? " " + className : "")}
            type={type}
            title={message || title}
            showIcon={true}
            {...extraOptions}
            {...other}
        />
    )
}

export default Alert;